// libs
import { styled } from '@nykaa/ui-components';

//components
import BaseButton from '@nykaa/ui-components/Button';
// import BaseButton from 'shared/components/Button';

export const Container = styled.div`
  justify-content: space-between;
  display: flex;
  border-color: ${({ theme }) => theme.colors.surface20};
  ${({ theme }) => theme.borders.border150};

  padding: ${({ theme }) =>
    `${theme.spacing.spacing60} ${theme.spacing.spacing120} ${theme.spacing.spacing60} ${theme.spacing.spacing100}`};
  background-color: ${({ theme }) => theme.colors.filterSurface};
  // @ts-expect-error - filterBackdropFilter is a custom property not in UI components ColorTokens type
  backdrop-filter: blur(${({ theme }) => theme.colors.filterBackdropFilter}px);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled(BaseButton) <{ $isApplyButton: boolean, kind: 'primary' | 'secondary' | 'tertiary' }>`
  border: ${({ theme }) => `1px solid ${theme.colors.textOutline}`};
  padding: ${({ theme }) => `${theme.spacing.spacing50} ${theme.spacing.spacing80}`};
  border-radius: ${({ theme }) => theme.borders.buttonBorderRadius};
  ${({ theme }) => theme.typography.buttonMedium};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};

  ${({ $isApplyButton, theme }) => $isApplyButton && `
    margin-left: ${theme.spacing.spacing40};
  `
  };
  ${({ kind, theme }) => kind === 'secondary' ? `
    background: ${theme.colors.surface};
    color: ${theme.colors.textPrimary};` :
    `
    background: ${theme.colors.primary};
    color: ${theme.colors.surface};
  `};

  &:disabled {
    color: ${({ theme }) => theme.colors.textDisabled};
    cursor: not-allowed;
  }
`;
